import { PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE } from '@/lib/constants';
import { normalizedEmailField } from '@/validation-schema/email-field';
import * as yup from 'yup';

export const userCreationSchema = yup.object({
  email: normalizedEmailField(),
  isGoogleSignup: yup.boolean().optional().default(true),
  password: yup.string().when('isGoogleSignup', {
    is: (val: boolean) => val !== true,
    then: (schema) =>
      schema
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters long')
        .matches(PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE),
    otherwise: (schema) => schema.optional(),
  }),
  firstName: yup
    .string()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters long')
    .max(50, 'First name must not exceed 50 characters')
    .matches(/^[a-zA-Z\s]+$/, 'First name can only contain letters and spaces'),
  lastName: yup
    .string()
    .required('Last name is required')
    .min(2, 'Last name must be at least 2 characters long')
    .max(50, 'Last name must not exceed 50 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Last name can only contain letters and spaces'),
  whatsappNumber: yup
    .string()
    .required('WhatsApp number is required')
    .matches(
      /^\+?[1-9]\d{1,14}$/,
      'Please enter a valid WhatsApp number (with or without country code)'
    ),
  referrerCode: yup
    .string()
    .optional()
    .transform((value) => value?.trim() || undefined)
    .max(32, 'Referral code must not exceed 32 characters'),
});

export type UserCreationFormData = yup.InferType<typeof userCreationSchema>;
